import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, map, mergeMap, Observable, of, take, throwError } from "rxjs";
import {
  fetchAuthSession, AuthSession,
  JWT
} from 'aws-amplify/auth';

const getToken = (): Observable<JWT | undefined | null> => {
  return from(fetchAuthSession()).pipe(
    map((session: AuthSession) => {
      return session.tokens?.idToken;
    }),
    catchError(() => {
      return of(null);
    }),
  );
};

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return getToken().pipe(
      mergeMap((token) => {
        if (token) {
          // Clone the request with the Authorization header
          const cloned = req.clone({
            headers: req.headers.set('Authorization', token.toString())
              .set('Content-Type', 'application/json'),
          });
          return next.handle(cloned).pipe(take(2));
        } else {
          return next.handle(req);
        }
      }),
      catchError((error) => {
        console.error('Interceptor error:', error);
        return throwError(() => error);
      }),
    );
  }


}
